import classNames from 'classnames';
import { format } from '@querodelivery/qd-date-helper';
import { Table } from '@quero-delivery/quero-components-web';
import { centsToMoneyLabel } from '@/Utils/FnUtils';
import styles from './extract-row.module.scss';
import type { Extract } from '../../api/types';

interface ExtractRowProps {
  extract: Extract;
  isFullTable: boolean;
}

function ExtractRow({ extract, isFullTable }: ExtractRowProps) {
  const descriptionField = extract.custom_fields.filter(
    item => item.key === 'descritivo',
  );

  return (
    <Table.Row key={extract._id}>
      <Table.Cell>
        <span className={styles.spanTable}>
          {format(new Date(extract.created_at), 'dd/MM/yyyy HH:mm')}
        </span>
      </Table.Cell>
      <Table.Cell>
        <span
          className={classNames(
            extract.cents > 0 ? styles.credit : styles.debit,
            styles.spanTable,
          )}
        >
          {centsToMoneyLabel(extract.cents)}
        </span>
      </Table.Cell>
      {isFullTable ? (
        <Table.Cell>
          <span className={styles.spanTable}>
            {centsToMoneyLabel(extract.balance)}
          </span>
        </Table.Cell>
      ) : null}
      <Table.Cell>
        <span
          className={classNames(
            extract.cents > 0 ? styles.credit : styles.debit,
            styles.spanTableCapitalized,
          )}
        >
          <p>{extract.tipo}</p>
        </span>
      </Table.Cell>
      <Table.Cell>
        <span className={styles.spanTableCapitalized}>
          <p>{extract.descricao}</p>
        </span>
      </Table.Cell>
      {isFullTable && descriptionField ? (
        <Table.Cell>
          <span className={styles.spanTable}>
            {descriptionField?.[0]?.value}
          </span>
        </Table.Cell>
      ) : null}
    </Table.Row>
  );
}

export { ExtractRow };
